import { render, staticRenderFns } from "./MarketLayout.vue?vue&type=template&id=fa105b08&"
import script from "./MarketLayout.vue?vue&type=script&lang=js&"
export * from "./MarketLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports